function helperGetDateTime (date) {
  return date.getTime()
}

module.exports = helperGetDateTime



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperGetDateTime.js
// module id = K2AN
// module chunks = 141